// function to format Date in -> date/month/year
export const formatDate = (dateTimeString) => {
  if (!dateTimeString) return ""; // If dateTimeString is empty, return empty string
  try {
    const date = new Date(dateTimeString);
    const day = date.getDate().toString().padStart(2, "0"); // Get day and pad with leading zero if needed
    const month = (date.getMonth() + 1).toString().padStart(2, "0"); // Get month (+1 because months are zero-based) and pad with leading zero if needed
    const year = date.getFullYear(); // Get year
    return `${day}/${month}/${year}`; // Concatenate day, month, and year in desired format
  } catch (error) {
    console.error("Error formatting date:", error);
    return ""; // Return empty string if an error occurs
  }
};
